import React from "react";
import { NavLink } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import "../style/footer.css";
import logo from "../images/logo.png";
const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-main">
        {/* Brand */}
        <div className="footer-col footer-brand footer-col-brand">
          <div className="footer-logo">
            <img src={logo} alt="Logo" className="logo-image" />
            JERRY'S BINS
          </div>
          <p>
            Fast, reliable and affordable skip bin hire services for homes,
            businesses and construction sites.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col footer-col-links">
          <h4>Quick Links</h4>
          <ul>
            <li><NavLink to="/">Home</NavLink></li>
            <li><NavLink to="/services">Services</NavLink></li>
            <li><NavLink to="/about-us">About Us</NavLink></li>
            <li><NavLink to="/commercial">Commercial</NavLink></li>
            <li><NavLink to="/contact">Contact</NavLink></li>
            <li><NavLink to="/faq">FAQ</NavLink></li>
          </ul>
        </div>

        {/* Bin Sizes */}
        <div className="footer-col footer-col-sizes">
          <h4>Skip Bin Sizes</h4>
          <ul>
            <li><NavLink to="/booking?bin=1">2m³ Skip Bin</NavLink></li>
            <li><NavLink to="/booking?bin=2">3m³ Skip Bin</NavLink></li>
            <li><NavLink to="/booking?bin=3">4m³ Skip Bin</NavLink></li>
            <li><NavLink to="/booking?bin=4">6m³ Skip Bin</NavLink></li>
            <li><NavLink to="/booking?bin=5">8m³ Skip Bin</NavLink></li>
            <li><NavLink to="/booking?bin=6">10m³ Skip Bin</NavLink></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col footer-col-contact">
          <h4>Get In Touch</h4>
          <ul className="footer-contact">
            <li>
              <MapPin size={16} />
              <span>Perth, Western Australia</span>
            </li>
            <li>
              <Phone size={16} />
              <span>+61 0495 000 017</span>
            </li>
            <li>
              <Mail size={16} />
              <span>admin@jerrysbinsperth.com.au</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <p>© {new Date().getFullYear()} Jerry's Bins. All rights reserved.</p>
          <div className="footer-bottom-links">
            <NavLink to="/privacy">Privacy Policy</NavLink>
            <NavLink to="/terms">Terms of Service</NavLink>
          </div>
        </div>

        {/* 3 Social Media Icons on Bottom Right */}
        <div className="footer-socials footer-bottom-socials">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95z"/>
            </svg>
          </a>
          <a href="https://www.instagram.com/jerrysbins?igsi=MXhmYXQ5bnp5bXEzMQ==" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
              <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
            </svg>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;